<script setup>
import { cn } from '@/lib/utils'

const props = defineProps({
    class: { type: null, required: false },
})
</script>

<template>
    <div
        class="scrollbar-default relative w-full overflow-auto rounded-sm"
    >
        <table :class="cn('w-full table-auto', props.class)">
            <slot />
        </table>
    </div>
</template>
